/**
 * MuiList
 *
 * Demos:
 *
 * - [Lists](https://ui-packages.isbuildingluma.com/ui-core/react-list/)
 *
 * API:
 *
 * - [List API](https://ui-packages.isbuildingluma.com/ui-core/api/list/)
 * - inherits [MuiList API](https://mui.com/material-ui/api/list/)
 *
 * Styles:
 *
 * - [Proto Sub Menu](https://www.figma.com/file/WJDRbOCCrGVDTsbUC3yvp8/Luma-Design-System?type=design&node-id=224-22515&t=AZf5inWOtq1eDrPf-0)
 */
const MuiList = {
  styleOverrides: {
    root: ({
      theme
    }) => ({
      padding: theme.spacing(),
      '& > .MuiListItemButton-root': {
        marginBottom: theme.spacing(),
        '&:last-child': {
          marginBottom: 0
        }
      }
    })
  }
};

/**
 * MuiListItemButton
 */
export const MuiListItemButton = {
  styleOverrides: {
    root: ({
      theme
    }) => ({
      borderRadius: 4,
      '& > .MuiListItemIcon-root': {
        minWidth: theme.spacing(4),
        '& svg': {
          fontSize: theme.typography.pxToRem(20)
        }
      },
      '&:hover': {
        backgroundColor: theme.palette.background.default,
        '& .MuiBadge-dot': {
          outlineColor: theme.palette.background.default
        },
        color: theme.palette.primary.main,
        '& svg': {
          color: theme.palette.primary.main
        }
      },
      '&:active': {
        backgroundColor: theme.palette.primary[300],
        '& .MuiBadge-dot': {
          outlineColor: theme.palette.primary[300]
        },
        '& svg': {
          color: theme.palette.primary.main
        }
      },
      '&.Mui-selected': {
        backgroundColor: theme.palette.primary[200],
        '& .MuiBadge-dot': {
          outlineColor: theme.palette.primary[200]
        },
        '& svg': {
          color: theme.palette.primary.main
        }
      },
      '&.MuiListItemButton-dense': {
        paddingTop: theme.spacing(0.75),
        paddingBottom: theme.spacing(0.75)
      }
    })
  }
};

/**
 * MuiListSubheader
 */
export const MuiListSubheader = {
  styleOverrides: {
    root: ({
      theme
    }) => ({
      textTransform: 'uppercase',
      color: theme.palette.primary.main,
      fontSize: 12,
      fontWeight: 600
    })
  }
};
export default MuiList;